module.exports = __webpack_public_path__ + "img/House_2_High_Set.17cb68d6.jpg";